/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { Header, AppCardListComp } from '../components';
import { useSMCreateSupplier, useSMSuppliersGetContent } from '../machines';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { SuppliersPageService } from '..//services';
import { VApplication } from '@/application';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
//import { TweetyModal } from "../../../widgets/tweety-widget-model";
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { useNavigate } from 'react-router-dom';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.SuppliersPageService') as SuppliersPageService;
};

export const ContainerComm = (props: any) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const srv = getSrv();

  useEffect(() => {
    srv?.resetCriteria();
  }, []);

  const { suppliersPageState, suppliersPageSend } = useSMSuppliersGetContent(
    {}
  );
  console.log('suppliersPageState', suppliersPageState);
  const { createSupplierSend, createSupplierState } = useSMCreateSupplier({});

  const onHeaderAction1Click = () => {
    if (!showModal) {
      setShowModal(true);
    }
  };

  const onError = () => {
    // window.location.reload(false);
  };

  const onPageChange = (page: number) => {
    console.log(`page change`, page);

    suppliersPageSend('TRIGGER_REFRESH', {
      offset: (page - 1) * 12,
      size: 12,
    });
  };

  const onRefresh = () => {
    suppliersPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    srv?.resetCriteria();
    suppliersPageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotifications = () => {
    if (createSupplierState?.matches('INITIATE_CREATE_SUPPLIER_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications.createSupplierSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    return null;
  };

  const onPaginationChange = (event: any) => {
    suppliersPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 12,
      size: 12,
    });
  };

  const onApplyFilter = (data: any) => {
    console.log('on applyfilter', data);
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    suppliersPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const onHeaderAction2Click = (id: string) => {
    if (id) {
      switch (id) {
        case 'import':
          navigate(`/bulk-import`);
          // history.push(
          //   `${routesConfig?.routes?.UsersBatch?.path}`
          // );
          break;
        default:
          console.log(`unsupported header button id ${id} clicked`);
      }
    }
  };

  const createSupplier = (data: any) => {
    console.log(`profile data`, data);
    if (showModal) {
      setShowModal(false);
    }
    createSupplierSend('MUTATE', {
      payload: data,
    });
  };
  const _renderPagination = () => {
    return (
      <Paginate
        {...(suppliersPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={suppliersPageState?.event?.data?.value?.appCardList?.length}
      />
    );
  };

  const _renderPage = () => {
    if (createSupplierState?.matches('INITIATE_CREATE_SUPPLIER')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingCreateSupplier || {})}
        />
      );
    }

    if (
      suppliersPageState?.matches('RENDER_PAGE') &&
      suppliersPageState?.event?.data?.value
    ) {
      return (
        <>
          {/* <AppCardListComp
            {...(suppliersPageState?.event?.data?.value || {})}
            onCardClick={props?.onCardClick}
            onPageChange={onPageChange}
          /> */}
          {suppliersPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <AppCardListComp
              {...(suppliersPageState?.event?.data?.value || {})}
              onCardClick={props?.onCardClick}
              onPageChange={onPageChange}
            />
          )}
        </>
      );
    }
    if (suppliersPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingHolderGroup || {})}
        />
      );
    }

    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderAction1Click={onHeaderAction1Click}
            onRefreshClick={onRefresh}
            onHeaderAction2Click={onHeaderAction2Click}
          />
        </>
      );
    }
    return null;
  };

  const _renderSearch = () => {
    return (
      <SearchFilter
        {...(staticPageContentConfig?.settings || {})}
        onFilterApply={onApplyFilter}
        onClearFilter={onClearFilter}
      />
      // <SettingsComp
      // {...staticPageContentConfig?.settings}
      // onApplyFilter={onApplyFilter}
      // onClearFilter={onClearFilter} />
    );
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        <TweetyModal
          show={true}
          size={'lg'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Add Supplier'}
          onSubmit={createSupplier}
          onHide={() => setShowModal(false)}
          title={'Add New Supplier'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.createSupplier?.FIELDS,
            layout: staticPageContentConfig?.createSupplier?.layout,
          }}
        />
      );
    }
  };
  const _renderErrorModals = () => {
    if (createSupplierState?.matches('INITIATE_CREATE_SUPPLIER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.createSupplier || {})}
          description={[
            createSupplierState?.event?.data?.value,
            staticPageContentConfig?.error?.createSupplier?.description[1],
          ]}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
    if (suppliersPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getGroup || {})}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
  };
  return (
    <>
      {_renderHeader()}
      {_renderSearch()}
      {_renderPage()}
      {_renderErrorModals()}
      {_renderPagination()}
      {_renderModal()}
      {_renderNotifications()}
    </>
  );
};
